import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "@media (min-width: 500px)": {
      width: "100%",
      ...shorthands.overflow("hidden"),
      ...shorthands.padding("0px", "0px", "0px", "12px"),
      ...shorthands.gap("8px"),
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
      "&:hover": {
        overflowY: "auto",
      },
    },
  },
});
